<template>
  <Page><exception-page type="403" :show-login-button="true" /></Page>
</template>

<script>
import ExceptionPage from '@/components/Exception'
import Page from '@/components/Page'

export default {
  components: {
    Page,
    ExceptionPage,
  },
}
</script>

<style scoped></style>
